import { Component, Input, Output, EventEmitter, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectOption } from '../../models/select-option';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],

})
export class AutocompleteComponent implements OnChanges {
  @Input() options: SelectOption[] = [];
  @Input() placeholder: string = 'Start typing...';
  @Input() selectedOption: SelectOption | null = null;
  isDropdownVisible = true;

  @Output() optionSelected = new EventEmitter<SelectOption>();

  myControl = new FormControl();
  filteredOptions: SelectOption[] = [];

  private updateFilteredOptions(value: string | null): void {
    const search = (value ?? '').toLowerCase().trim();
    this.filteredOptions = search
      ? this.options.filter(item => item.name.toLowerCase().includes(search))
      : [...this.options];
  }

  selectOption(option: SelectOption) {
    this.myControl.setValue(option.name, { emitEvent: false });
    this.optionSelected.emit(option);
    this.isDropdownVisible = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedOption']) {
      const val = changes['selectedOption'].currentValue as SelectOption | null;
      this.myControl.setValue(val ? val.name : '', { emitEvent: false });
      this.isDropdownVisible = false;
    }
  }
  
  onInputChange() {
    this.isDropdownVisible = true;
    this.updateFilteredOptions(this.myControl.value);
    if (!this.myControl.value || this.myControl.value.trim() === '') {
      this.optionSelected.emit(null);
    }
  }

  onInputFocus() {
    this.updateFilteredOptions(this.myControl.value);
    this.isDropdownVisible = true;
  }

  onInputBlur() {
    // Delay hiding to allow click on dropdown items
    setTimeout(() => {
      this.isDropdownVisible = false;
    }, 150);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.form-group')) {
      this.isDropdownVisible = false;
    }
  }
}
